import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function ProofSection() {
  const faqs = [{
    question: '¿Necesito comprar muebles nuevos?',
    answer: 'No. El 95% de los ajustes se hacen con lo que ya tienes.'
  }, {
    question: '¿Sirve si rento un departamento pequeño?',
    answer: 'Sí, es ideal para espacios de cualquier tamaño porque se basa en la ubicación, no en el metraje.'
  }, {
    question: '¿Cuánto tiempo toma ver resultados?',
    answer: 'El descanso suele mejorar desde la primera noche tras ajustar la cama.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFaq = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white relative" data-id="element-132">
      <div className="max-w-4xl mx-auto" data-id="element-133">
        {/* Proof / Quote */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="mb-24 relative" data-id="element-134">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 text-gold opacity-20 text-9xl font-serif leading-none select-none" data-id="element-135">
            "
          </div>
          <div className="text-center px-4 sm:px-12 py-12 border-y border-gold/30 relative z-10" data-id="element-136">
            <p className="text-2xl sm:text-3xl font-serif italic text-charcoal leading-relaxed mb-8" data-id="element-137">
              He estudiado con los maestros más respetados de Oriente. Mi
              práctica de Feng Shui de años me ha enseñado que lo que tu cuarto
              permite, tu vida lo repite. Aplicar estos principios no es
              sugestión; es devolverle al cuerpo el sostén físico y simbólico
              que necesita para prosperar.
            </p>
            <p className="text-sage font-medium tracking-wide uppercase" data-id="element-138">
              — Janeth Schmidt
            </p>
          </div>
        </motion.div>

        {/* FAQ */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-139">
          <h2 className="text-3xl sm:text-4xl font-serif text-center text-charcoal mb-12" data-id="element-140">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-141">
            {faqs.map((faq, index) => <div key={index} className="border border-sage/20 rounded-xl overflow-hidden bg-cream/30" data-id="element-142">
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus:ring-2 focus:ring-inset focus:ring-sage/50" aria-expanded={openIndex === index} data-id="element-143">
                  <span className="text-lg font-medium text-charcoal pr-4" data-id="element-144">
                    {faq.question}
                  </span>
                  <ChevronDownIcon className={`w-5 h-5 text-sage flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-145" />
                </button>
                <AnimatePresence data-id="element-146">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-147">
                      <div className="px-6 pb-5 text-charcoal/70 text-lg leading-relaxed" data-id="element-148">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}